import { designToken, quickProperty } from '../component-tokens';
export const treeViewTokens = {
    name: 'tree-view',
    tag: 'chameleon-tree-view',
    reactImports: 'TreeView',
    attributes: {
        font: designToken('body-small'),
        width: quickProperty('100%'),
    },
    children: [
        {
            name: 'tree-item',
            tag: 'chameleon-tree-item',
            attributes: {
                'background-color': quickProperty('transparent'),
                border: quickProperty('1px solid transparent'),
                'min-height': designToken('spacing-07'),
                margin: quickProperty('0.125rem'),
            },
            children: [
                {
                    name: 'expand-collapse-button',
                    attributes: {},
                },
                {
                    name: 'end',
                    attributes: {
                        'flex-grow': quickProperty('1'),
                        'justify-content': quickProperty('flex-end'),
                        'margin-right': designToken('spacing-03'),
                    },
                },
                {
                    name: 'positioning-region',
                    attributes: {
                        border: quickProperty('none'),
                        color: designToken('type-color-default'),
                        'background-color': quickProperty('transparent'),
                    },
                    states: [
                        {
                            name: 'hover',
                            attributes: {
                                'background-color': designToken('interactive-color-secondary-hover'),
                            },
                        },
                        {
                            name: 'selected',
                            attributes: {
                                'background-color': designToken('interactive-color-secondary-pressed'),
                                color: designToken('type-color-default'),
                            },
                        },
                    ],
                },
            ],
        },
    ],
};
